export default __webpack_public_path__ + "static/strategy_overview_img-af00f55932af464718b123a25b49b0c5.png";